import { createDynamicMiddlewares } from 'redux-dynamic-middlewares';

const sportsbookDynamicMiddlewares = createDynamicMiddlewares();
export default sportsbookDynamicMiddlewares;
